import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=3e1186d4&scoped=true"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=3e1186d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1186d4",
  null
  
)

export default component.exports